import { BREADCRUMB_STORAGE } from './storageConfig'
import { Breadcrumb } from '../models/interfaces/breadcrumb.interface'

export function storageBreadcrumbSave (breadcrumb: Breadcrumb[]) {
  localStorage.setItem(BREADCRUMB_STORAGE, JSON.stringify(breadcrumb))
}

export function storageBreadcrumbLoad () {
  const storage = localStorage.getItem(BREADCRUMB_STORAGE)
  const breadcrumb: Breadcrumb[] = storage ? JSON.parse(storage) : []
  return breadcrumb
}
